import domUtil from "lib/dom/dom-util"

let appliedTheme

export function toggleTheme(theme) {
  const bodyRef = domUtil.findFirst("body", null)

  if (domUtil.hasClass(bodyRef, "men")) {
    appliedTheme = "men"
  }

  if (domUtil.hasClass(bodyRef, "women")) {
    appliedTheme = "women"
  }

  if (domUtil.hasClass(bodyRef, "default")) {
    appliedTheme = "default"
  }

  domUtil.removeClass(bodyRef, appliedTheme)
  domUtil.addClass(bodyRef, theme)
}

export function getProductTheme(url) {
  return url.split("/")[2] === "mens" ? "men" : "women"
}
